<template>
    <div class="fill-height" :class="$vuetify.breakpoint.smAndDown ? 'white' : ''">
        <div v-if="loadingMedicalRecords" class="py-12 text-center d-flex justify-center fill-height align-center">
            <v-progress-circular
                    :size="50"
                    :width="5"
                    color="primary"
                    indeterminate
            ></v-progress-circular>
        </div>
        <v-card  style="" flat tile class="mb-4" v-else>
            <v-card-title>
            <v-col cols="12" sm="8" class="ma-0 pa-0">
                {{ medicalRecordDetails.name }}                    
            </v-col>
            
                <v-col cols="12" sm="8" class="ma-0 pa-0 font-16" >
                    {{ medicalRecordDetails.type }}                    
                </v-col>
                <v-col cols="12" sm="4" class="ma-0 pa-0">
                    <v-btn :loading="deleteLoading"   @click="deleteRecord()"  outlined color="red" small class="mr-2 text-right float-right">Delete</v-btn>
                </v-col>
                
            </v-card-title>
            <v-card-text class="">
            <span class="grey--text text--darken-1">
                Uploaded On {{ dateutils.utcToLocal(medicalRecordDetails.created_at).format('dddd, D MMMM YYYY') }}
            </span>
                <br><br>
                <v-row>
                    <v-col
                    class="d-flex justify-space-between flex-column"
                    
                     cols="12" sm="12" md="6" v-for="document in medicalRecordDetails.patient_documents" :key="document.id">
                        
                        <div class="d-flex justify-center" style="height:180px;">
                            <v-img :src="getImagePath(document)"
                                contain
                                max-width="300"
                                max-height="300"
                                v-if="checkImage(document)" class="pointer" @click="imageDialog = true;clickedDoc = getImagePath(document)"
                            >
                            </v-img>

                             <v-icon v-else x-large style="font-size:120px;" @click="downloadFile(document)">mdi-file</v-icon>
                        </div>                        
                        <a href="javascript:void(0)" @click="downloadFile(document)" class="darkPrimary--text text-center mt-4">Download File</a>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card style="" flat tile>
            <v-card-text class="">
            <span class="grey--text text--darken-1">
                Shared With
            </span>
                <br><br>
                <v-chip v-for="doctor in medicalRecordDetails.doctors" :key="doctor.id" close
                        @click:close="confirmRemoval(doctor)" class="mr-2">
                    {{doctor.salutation}} {{ doctor.name }}
                </v-chip>
                <br v-if="medicalRecordDetails.doctors.length"><br v-if="medicalRecordDetails.doctors.length">
                <a href="javascript:void(0)" @click="shareDocumentModal = true" class="darkPrimary--text">Share with other Doctors</a>
            </v-card-text>
        </v-card>

        <!--        UnShare Modal-->
        <v-dialog v-model="hideDocumentConfirmModal" max-width="500">
            <v-card>
                <v-card-title class="headline">Hide Document</v-card-title>
                <v-card-text class="">
                    <h3 class="font-weight-regular">
                        Are you sure you wish to hide this record from <b>{{ currentDoctor.salutation }} {{
                        currentDoctor.name }}</b>
                    </h3>
                </v-card-text>
                <v-card-actions class="">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="hideDocumentConfirmModal = false" class="mr-3">
                        Close
                    </v-btn>
                    <v-btn color="primary" @click.prevent="removeSharedDocument" :loading="loading" :disabled="loading">
                        Remove
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--        Share Modal-->
        <v-dialog v-model="shareDocumentModal" max-width="800">
            <v-card style="position: relative">
                <v-card-title class="headline">Share Record</v-card-title>
                <v-card-text class="">
                    <h3 class="font-weight-regular">
                        Select Doctors to share with
                    </h3>

                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left"></th>
                                <th class="text-left">Name</th>
                                <th class="text-left">Speciality</th>
                                <th class="text-left"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="doctor in doctorList" :key="doctor.id">
                                <td>
                                    <v-icon style="font-size: 40px;" color="primary">
                                        mdi-account-circle
                                    </v-icon>
                                </td>
                                <td>
                                    {{ doctor.salutation }} {{ doctor.name }}
                                </td>
                                <td>
                                    <span v-for="specialization in doctor.specializations"
                                          :key="specialization.id">
                                                                {{ specialization.name }}
                                                            </span>
                                </td>
                                <td>
                                    <v-checkbox v-model="selectedDoctors" :value="doctor.id"></v-checkbox>
                                </td>
                            </tr>
                            <tr v-if="!doctorList.length">
                                <td colspan="4" class="text-center">
                                    <div class="text-center my-6">
                                        <v-icon large>mdi-alert</v-icon>
                                        <br>
                                        <h3 class="font-weight-regular">No Doctors Found</h3>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions class="">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="shareDocumentModal = false" class="mr-3">
                        Close
                    </v-btn>
                    <v-btn color="primary" class="black--text" @click.prevent="shareDocumentWithDoctors" :loading="loading" :disabled="loading || !doctorList.length">
                        Share
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="imageDialog"
                scrollable
                :overlay="false"
                :key="medicalRecordDetails.id"
                max-width="900px"
                transition="dialog-transition"
        >
            <img :src="clickedDoc" alt="">
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        
        name: 'MedicalRecordDetails',
        props: ['medicalRecordDetailsProp', 'showActions'],
        computed: {
            ...mapGetters([          
                'userInfo'
            ]),
        },
        data() {
            return {
                hideDocumentConfirmModal: false,
                shareDocumentModal: false,
                imageDialog: false,
                clickedDoc:"",
                loading: false,
                deleteLoading: false,
                src: '',
                selectedDocument: {},
                currentDoctor: {},
                doctorList: [],
                selectedDoctors: [],
                loadingMedicalRecords:false,
                recordId:"",
                medicalRecordDetails:{}
            }
        },
        mounted() {            
         
            
        this.medicalRecordDetails = this.medicalRecordDetailsProp
        this.getDoctorsList();
        this.getImagePath();            
        this.setSharedWithDoctors();
                
            
                
        },
        methods: {
            getMedicalRecord: function () {
                if (!this.userInfo) {
                    return;
                }
                this.loadingMedicalRecords = true;          
                return new Promise((resolve) => {
                    this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/medical-records/${this.medicalRecordDetails.id}`)
                    .then((response) => {
                        if (response.data.status === 1) {
                            this.medicalRecordDetails = response.data.data
                        }                        
                    }).catch((error) => {
                        console.log(error);
                        
                    })
                    .finally(() => {                        
                        this.loadingMedicalRecords = false;
                        resolve()
                    })
                })      
                
            },
            setSharedWithDoctors(){                
                this.selectedDoctors = []
                this.medicalRecordDetails.doctors.forEach(element => {
                    this.selectedDoctors.push(element.id)
                });
            },
            getDoctorsList() {
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/doctors`).then((response) => {
                    if (response.data.status === 1) {
                        this.doctorList = response.data.data;
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            confirmRemoval(doctor) {
                this.hideDocumentConfirmModal = true;
                this.currentDoctor = doctor;
            },
            shareDocumentWithDoctors() {
                this.loading = true;
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/medical-records/share-with-doctors`, {
                    medical_record_id: this.medicalRecordDetails.id,
                    doctor_ids: this.selectedDoctors,
                }).then((response) => {
                    if (response.data.status === 1) {
                        this.shareDocumentModal = false;
                        this.medicalRecordDetails.doctors = response.data.data
                        this.setSharedWithDoctors()  
                        this.$store.commit('showSnackbar', {message: response.data.message})                      
                    }
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                  this.loading = false;
                });
            },
            removeSharedDocument() {
                this.loading = true;
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/medical-records/unshare-with-doctors`, {
                    doctor_id: this.currentDoctor.id,
                    medical_record_id: this.medicalRecordDetails.id,
                }).then((response) => {                    
                    if (response.data.status === 1) {
                        this.medicalRecordDetails.doctors.splice(this.medicalRecordDetails.doctors.indexOf(this.currentDoctor), 1);
                        this.hideDocumentConfirmModal = false;
                    }
                    
                    this.setSharedWithDoctors()
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                });
            },
            checkImage(document) {
                let splitPath = document.path.split(".")
                let extension = splitPath[splitPath.length - 1]
                let imageExtensions = ["gif", "jpg", "jpeg", "png","JPG"]
                return imageExtensions.includes(extension)
            },
            downloadFile(document) {                

                var url = process.env.VUE_APP_API_URL + "/storage/" + document.path
                window.open(url, "_blank");                
            },
            getImagePath(document) {
                if(document!=null)
                return process.env.VUE_APP_API_URL + '/storage/' + document.path;
            },
            deleteRecord(){
                this.deleteLoading = true;
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/medical-records/`+this.medicalRecordDetails.id+`/delete`)
                .then((response) => {                    
                    if (response.data.status === 1) {
                        console.log("REFRESH")
                        this.$emit('refreshList')
                    }                                    
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    this.deleteLoading = false;
                });
            }
        }
    }
</script>
